import { REQUEST_KEYS } from '../constants';
import request from '../request/request';
var getUserInfo = function () { return request(REQUEST_KEYS.AUTH_GET_USER_INFO, undefined, { forceTryAgain: true }); };
export default getUserInfo;
